<template>
  <div>
    <div class="row">
      <div :class="['col_12', {'loading_overlay': loading}]">
        <div class="card no_border">
          <div class="card-header">
            <div class="card-title">{{ title }}</div>
          </div>
          <div class="card-body pl_0 pr_0">
            <div class="row">
              <div class="col_6">
                <div :class="['form-group', {'has_error': errorFor('page_name')}]">
                  <label>{{ $t('sidebar.seo.page_title') }}</label>
                  <input type="text" v-model="form.page_name" class="form_global">
                  <v-errors :errors="errorFor('page_name')" />
                </div>
              </div>
              <div class="col_6">
                <div :class="['form-group', {'has_error': errorFor('meta_title')}]">
                  <label>{{ $t('sidebar.seo.meta_title') }}</label>
                  <input type="text" v-model="form.meta_title" class="form_global">
                  <v-errors :errors="errorFor('meta_title')" />
                </div>
              </div>
              <div class="col_12">
                <div :class="['form-group', {'has_error': errorFor('meta_description')}]">
                      <label>{{ $t('sidebar.seo.meta_description') }}</label>
                  <textarea v-model="form.meta_description" class="form_global"></textarea>
                      <v-errors :errors="errorFor('meta_description')"></v-errors>
                  </div>
              </div>
              <div class="col_12">
                <div :class="['form-group', {'has_error': errorFor('meta_keywords')}]">
                      <label>{{ $t('sidebar.seo.meta_keywords') }}</label>
                  <textarea v-model="form.meta_keywords" class="form_global"></textarea>
                      <v-errors :errors="errorFor('meta_keywords')"></v-errors>
                  </div>
              </div>
            </div>
            <div class="d_flex_end form_action_btn">
              <router-link class="btn btn_blue ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
              <button class="btn btn_blue ml_10" @click.prevent="submit">{{ $t('common.save') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SeoManageForm",
  data() {
    return {
      title: this.$t('sidebar.seo.add_new'),
      cancelRouteName: 'seo_manage_index',
      form: {
        page_name: '',
        meta_title: '',
        meta_description: '',
        meta_keywords: '',
      },
      tempSliderImage:'',
    }
  },
  components: {  },
  created() {
    if (this.$route.name === 'seo_manage_edit') {
      this.axios.get('/seo-contents/'+this.$route.params.id)
        .then((response) => {
          this.form = response.data.data;
        })
      this.title = this.$t('sidebar.seo.edit_seo_content');
    }
  },
  methods: {
    submit() {
      this.allErrors = null;
      this.loading = true;

      let formData = new FormData()

      Object.keys(this.form).forEach(key => {
          formData.append(key, this.form[key] ? this.form[key] : '');
      })

      if (this.$route.name === 'seo_manage_edit') {
        formData.append('_method', 'PUT');
        this.axios.post('/seo-contents/'+this.$route.params.id, formData)
          .then(() => {
            this.$router.push({name: 'seo_manage_index'});
            this.showSuccessMsg(this.$t('common.updateSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.axios.post('/seo-contents', formData)
          .then(() => {
            this.$router.push({name: 'seo_manage_index'});
            this.showSuccessMsg(this.$t('common.addSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
}
</script>
<style scoped>

</style>